import Images from "../../constants/Images";

import "./TopBar.css";

export default function TopBar() {
  return (
    <div className="topBar-container">
      <a className="topBar-titleContainer" href="/">
        <img
          src={Images.appIcon}
          alt="Inspo app icon"
          className="topBar-appIcon"
        />
        <div className="topBar-titleFont">inspo</div>
      </a>
    </div>
  );
}
